import React from 'react';
import { Brain, Compass, BarChart3, TrendingUp } from 'lucide-react';

const TalentIntelligence = () => {
  const capabilities = [
    { icon: Compass, text: 'Guides training and role-play creation' },
    { icon: BarChart3, text: 'Evaluates readiness and skill progression' },
    { icon: TrendingUp, text: 'Surfaces performance insights leaders can trust' },
    { icon: Brain, text: 'Helps teams improve without increasing oversight' }
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="p-8 md:p-12 rounded-3xl bg-gradient-to-br from-indigo-900/30 to-purple-900/30 border border-purple-500/30">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-3 mb-6">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-2xl flex items-center justify-center">
                <Brain className="w-7 h-7 text-white" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white">
                Navigator AI™
              </h2>
            </div>
            <p className="text-xl text-purple-400 font-semibold mb-6">
              Intelligence That Guides — Not Replaces
            </p>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Navigator AI™ is Traain's intelligence layer that:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12">
            {capabilities.map((capability, index) => {
              const Icon = capability.icon;
              return (
                <div
                  key={index}
                  className="flex items-center gap-4 p-5 rounded-xl bg-gray-900/50 border border-purple-500/20"
                >
                  <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-purple-400" />
                  </div>
                  <p className="text-gray-300">{capability.text}</p>
                </div>
              );
            })}
          </div>

          <div className="text-center">
            <p className="text-xl text-white font-semibold">
              This is AI designed to empower humans — not replace them.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TalentIntelligence;
